import styled from 'styled-components';
import { CardVariant, GRID_VARIANTS } from './grid-cards-types';

export const GridContainer = styled.div`
    width: 100%;
`;

export const EmptyGridMessageContainer = styled.div`
    padding: 1rem;
    gap: 0.5rem;
    display: flex;
    flex-flow: column;
    color: white;
    max-width: 600px;
    width: max-content;
    height: 256px;
    align-self: center;
    justify-self: center;
    justify-content: center;
    color: ${({ theme }) => theme?.colors?.text?.neutral};

    img {
        width: 32px;
        filter: ${({ theme }) =>
        theme?.name === "dark"
            ? "none"
            : "invert(0%) brightness(0%)"};
    }
`;

export const StyledGrid = styled.div<{ gap?: number; $variant: CardVariant }>`
    display: grid;
    gap: ${({ gap }) => gap ?? 24}px;
    width: 100%;

    /* Mobile first - single column centered */
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    justify-items: center;

    /* Responsive breakpoints */
    @media (min-width: 480px) {
        grid-template-columns: repeat(${({ $variant }) => GRID_VARIANTS[$variant].columns.sm}, minmax(0, 1fr));
        justify-items: ${({ $variant }) => GRID_VARIANTS[$variant].columns.sm === 1 ? 'center' : 'stretch'};
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(${({ $variant }) => GRID_VARIANTS[$variant].columns.md}, minmax(0, 1fr));
        justify-items: ${({ $variant }) => GRID_VARIANTS[$variant].columns.md === 1 ? 'start' : 'stretch'};
    }

    @media (min-width: 1024px) {
        width: ${({ $variant }) => $variant === 'campaignOverflow' && "1000px"};
        grid-template-columns: repeat(${({ $variant }) => GRID_VARIANTS[$variant].columns.lg}, minmax(0, 1fr));
        justify-items: ${({ $variant }) => GRID_VARIANTS[$variant].columns.lg === 1 ? 'center' : 'stretch'};
    }
`;